import * as InstrumentGroupManagementConstants from "./InstrumentGroupManagementConstants";
import * as CommonConstants from "Common/constants/commonConstants";

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require("object.assign");

const initialState = {
  searchDevicesStatus: CommonConstants.STATUS_SUCCESS,
  searchDevicesErrMsg: "",
  searchDevices: [],
  fetchInstrGrpDevicesStatus: CommonConstants.STATUS_SUCCESS,
  fetchInstrGrpDevicesErrMsg: "",
  instGrpDevices: [],
  displayInstGrpDevices: [],
  checkIfDeviceInInstGrpStatus: CommonConstants.STATUS_SUCCESS,
  checkIfDeviceInInstGrpErrMsg: "",
  instsToAddInGrp: [],
  instsToRemoveInGrp: [],
  saveInstMapStatus: CommonConstants.STATUS_COMPLETED,
  saveInstMapErrMsg: "",
};

export default function InstrumentGroupManagementReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case InstrumentGroupManagementConstants.SEARCH_DEVICES_REQUEST: {
      const newState = {
        ...state,
        searchDevicesStatus: CommonConstants.STATUS_PENDING,
        searchDevicesErrMsg: "",
        searchDevices: [],
      };
      return assign({}, state, newState);
    }
    case InstrumentGroupManagementConstants.SEARCH_DEVICES_SUCCESS: {
      const newState = {
        ...state,
        searchDevicesStatus: CommonConstants.STATUS_SUCCESS,
        searchDevicesErrMsg: "",
        searchDevices: [...action.payload],
      };
      return assign({}, state, newState);
    }
    case InstrumentGroupManagementConstants.SEARCH_DEVICES_ERROR: {
      const newState = {
        ...state,
        searchDevicesStatus: CommonConstants.STATUS_FAILURE,
        searchDevicesErrMsg:
          action.payload?.debugMessage ||
          InstrumentGroupManagementConstants.GENERIC_ERROR_MESSAGE,
        searchDevices: [],
      };
      return assign({}, state, newState);
    }

    case InstrumentGroupManagementConstants.INST_GROUP_DEVICES_FETCH_REQUEST: {
      const newState = {
        ...state,
        fetchInstrGrpDevicesStatus: CommonConstants.STATUS_PENDING,
        fetchInstrGrpDevicesErrMsg: "",
        instGrpDevices: [],
        displayInstGrpDevices: [],
        instsToAddInGrp: [],
        instsToRemoveInGrp: [],
      };
      return assign({}, state, newState);
    }
    case InstrumentGroupManagementConstants.INST_GROUP_DEVICES_FETCH_SUCCESS: {
      const newState = {
        ...state,
        fetchInstrGrpDevicesStatus: CommonConstants.STATUS_SUCCESS,
        fetchInstrGrpDevicesErrMsg: "",
        instGrpDevices: [...state.instGrpDevices, ...action.payload],
        displayInstGrpDevices: [
          ...state.displayInstGrpDevices,
          ...action.payload,
        ],
      };
      return assign({}, state, newState);
    }
    case InstrumentGroupManagementConstants.INST_GROUP_DEVICES_FETCH_ERROR: {
      const newState = {
        ...state,
        fetchInstrGrpDevicesStatus: CommonConstants.STATUS_FAILURE,
        fetchInstrGrpDevicesErrMsg:
          action.payload?.debugMessage ||
          InstrumentGroupManagementConstants.GENERIC_ERROR_MESSAGE,
      };
      return assign({}, state, newState);
    }

    case InstrumentGroupManagementConstants.ADD_INST_TO_INST_GRP_REQUEST: {
      const newState = {
        ...state,
        checkIfDeviceInInstGrpStatus: CommonConstants.STATUS_PENDING,
        checkIfDeviceInInstGrpErrMsg: "",
      };
      return assign({}, state, newState);
    }
    case InstrumentGroupManagementConstants.ADD_INST_TO_INST_GRP_SUCCESS: {
      const newState = {
        ...state,
        checkIfDeviceInInstGrpStatus: CommonConstants.STATUS_SUCCESS,
        checkIfDeviceInInstGrpErrMsg: "",
        displayInstGrpDevices: [action.payload, ...state.displayInstGrpDevices],
        instsToAddInGrp: [...state.instsToAddInGrp, action.payload.instanceId],
      };
      return assign({}, state, newState);
    }
    case InstrumentGroupManagementConstants.ADD_INST_TO_INST_GRP_ERROR: {
      const newState = {
        ...state,
        checkIfDeviceInInstGrpStatus: CommonConstants.STATUS_FAILURE,
        checkIfDeviceInInstGrpErrMsg: action.payload,
      };
      return assign({}, state, newState);
    }
    case InstrumentGroupManagementConstants.REMOVE_INST_FROM_INSTS_TO_REMOVE_IN_GRP_LIST: {
      const newState = {
        ...state,
        instsToRemoveInGrp: [
          ...state.instsToRemoveInGrp.filter(
            (el) => el !== action.payload.instanceId
          ),
        ],
        displayInstGrpDevices: [action.payload, ...state.displayInstGrpDevices],
      };

      return assign({}, state, newState);
    }
    case InstrumentGroupManagementConstants.CLOSE_ADD_INST_TO_GRP_ERR_POPUP: {
      const newState = {
        ...state,
        checkIfDeviceInInstGrpStatus: CommonConstants.STATUS_SUCCESS,
        checkIfDeviceInInstGrpErrMsg: "",
      };
      return assign({}, state, newState);
    }
    case InstrumentGroupManagementConstants.REMOVE_INST_FROM_INST_GRP: {
      let newInstsToAddInGrp = [...state.instsToAddInGrp];
      let newInstsToRemoveInGrp = [...state.instsToRemoveInGrp];

      if (state.instsToAddInGrp.includes(action.payload.instanceId)) {
        newInstsToAddInGrp = newInstsToAddInGrp.filter(
          (el) => el !== action.payload.instanceId
        );
      } else {
        newInstsToRemoveInGrp = [
          ...newInstsToRemoveInGrp,
          action.payload.instanceId,
        ];
      }

      const newState = {
        ...state,
        displayInstGrpDevices: [
          ...state.displayInstGrpDevices.filter(
            (el) => el.instanceId !== action.payload.instanceId
          ),
        ],
        instsToAddInGrp: newInstsToAddInGrp,
        instsToRemoveInGrp: newInstsToRemoveInGrp,
      };
      return assign({}, state, newState);
    }

    case InstrumentGroupManagementConstants.SAVE_INST_GRP_MAP_REQUEST: {
      const newState = {
        ...state,
        saveInstMapStatus: CommonConstants.STATUS_PENDING,
        saveInstMapErrMsg: "",
      };

      return assign({}, state, newState);
    }
    case InstrumentGroupManagementConstants.SAVE_INST_GRP_MAP_SUCCESS: {
      const newState = {
        ...state,
        saveInstMapStatus: CommonConstants.STATUS_SUCCESS,
        saveInstMapErrMsg: "",
        instGrpDevices: [...state.displayInstGrpDevices],
        instsToAddInGrp: [],
        instsToRemoveInGrp: [],
      };

      return assign({}, state, newState);
    }
    case InstrumentGroupManagementConstants.SAVE_INST_GRP_MAP_ERROR: {
      const newState = {
        ...state,
        saveInstMapStatus: CommonConstants.STATUS_FAILURE,
        saveInstMapErrMsg:
          action.payload?.responseJSON?.debugMessage ||
          InstrumentGroupManagementConstants.GENERIC_ERROR_MESSAGE,
      };

      return assign({}, state, newState);
    }
    case InstrumentGroupManagementConstants.CLOSE_INST_GRP_MAP_MSG: {
      const newState = {
        ...state,
        saveInstMapStatus: CommonConstants.STATUS_COMPLETED,
        saveInstMapErrMsg: "",
      };

      return assign({}, state, newState);
    }
    case InstrumentGroupManagementConstants.CANCEL_INST_GROUP_MAP: {
      const newState = {
        ...state,
        displayInstGrpDevices: [...state.instGrpDevices],
        instsToAddInGrp: [],
        instsToRemoveInGrp: [],
      };

      return assign({}, state, newState);
    }

    case InstrumentGroupManagementConstants.RESET_INST_GRP_STATE: {
      return {}, state, { ...initialState };
    }
    default:
      return state;
  }
}
